import { Directive, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { TypedChanges } from '@platform-frontend/util';

@Directive({
  selector: '[yatVar]'
})
export class VarDirective<T> implements OnChanges {
  constructor(private viewContainerRef: ViewContainerRef, private templateRef: TemplateRef<T>) {}

  @Input('yatVar')
  var: T | null;

  @Input()
  yatVarIfNull?: TemplateRef<unknown>;

  static ngTemplateContextGuard<T>(_: VarDirective<T>, context: unknown): context is { $implicit: T | null; yatVar: T | null } {
    return true;
  }

  ngOnChanges(changes: TypedChanges<VarDirective<any>>): void {
    if (changes.var || changes.yatVarIfNull) {
      this.updateView();
    }
  }

  private updateView(): void {
    this.viewContainerRef.clear();
    this.viewContainerRef.createEmbeddedView(this.getTemplateRef(), this.getContext());
  }

  private getTemplateRef(): TemplateRef<T | unknown> {
    if (this.var === null && this.yatVarIfNull) {
      return this.yatVarIfNull;
    } else {
      return this.templateRef;
    }
  }

  private getContext(): { $implicit: T | null; yatVar: T | null } {
    return {
      $implicit: this.var,
      yatVar: this.var
    };
  }
}
